import "./pCasemanMatch/pCasemanMatch.sass";
import "./pCasemanProjectConfig/pCasemanProjectConfig.sass";
import "./pCasemanMatchProcess/pCasemanMatchProcess.sass";
import "./pCasemanCustomizeProcess/pCasemanCustomizeProcess.sass";
import "./pCasemanSync/pCasemanSync.sass";
import "./pCasemanSiteConfig/pCasemanSiteConfig.sass";
import "./pCasemanTeamsConfig/pCasemanTeamsConfig.sass";
import "./pCasemanTeamConfig/pCasemanTeamConfig.sass";
import "./pCasemanTeamUserConfig/pCasemanTeamUserConfig.sass";
import "./pCasemanUserConfig/pCasemanUserConfig.sass";
import "./pCasemanClientConfig/pCasemanClientConfig.sass";
import "./pCasemanClientNewConfig/pCasemanClientNewConfig.sass";
import "./pCasemanTeamClientConfig/pCasemanTeamClientConfig.sass";
import "./pCasemanTeamClientErp/pCasemanTeamClientErp.sass";
import "./pCasemanPgConfig/pCasemanPgConfig.sass";
import "./pCasemanTeamPgConfig/pCasemanTeamPgConfig.sass";
import "./pCasemanProcessConfig/pCasemanProcessConfig.sass";
import "./pCasemanTeamProcessConfig/pCasemanTeamProcessConfig.sass";
import "./bMatchActions/bMatchActions.sass";
import "./bCasemanMenu/bCasemanMenu.sass";
import "./pCasemanIntegrationSettings/pCasemanIntegrationSettings.sass";

import { pCasemanMatchDirective } from "./pCasemanMatch/pCasemanMatch.directive";
import { pCasemanProjectConfigDirective } from "./pCasemanProjectConfig/pCasemanProjectConfig.directive";
import { pCasemanMatchProcessDirective } from "./pCasemanMatchProcess/pCasemanMatchProcess.directive";
import { pCasemanCustomizeProcessDirective } from "./pCasemanCustomizeProcess/pCasemanCustomizeProcess.directive";
import { pCasemanSyncDirective } from "./pCasemanSync/pCasemanSync.directive";
import { pCasemanSiteConfigDirective } from "./pCasemanSiteConfig/pCasemanSiteConfig.directive";
import { pCasemanTeamsConfigDirective } from "./pCasemanTeamsConfig/pCasemanTeamsConfig.directive";
import { pCasemanTeamConfigDirective } from "./pCasemanTeamConfig/pCasemanTeamConfig.directive";
import { pCasemanTeamUserConfigDirective } from "./pCasemanTeamUserConfig/pCasemanTeamUserConfig.directive";
import { pCasemanUserConfigDirective } from "./pCasemanUserConfig/pCasemanUserConfig.directive";
import { pCasemanClientConfigDirective } from "./pCasemanClientConfig/pCasemanClientConfig.directive";
import { pCasemanClientNewConfigDirective } from "./pCasemanClientNewConfig/pCasemanClientNewConfig.directive";
import { pCasemanTeamClientConfigDirective } from "./pCasemanTeamClientConfig/pCasemanTeamClientConfig.directive";
import { pCasemanTeamClientErpDirective } from "./pCasemanTeamClientErp/pCasemanTeamClientErp.directive";
import { pCasemanPgConfigDirective } from "./pCasemanPgConfig/pCasemanPgConfig.directive";
import { pCasemanTeamPgConfigDirective } from "./pCasemanTeamPgConfig/pCasemanTeamPgConfig.directive";
import { pCasemanProcessConfigDirective } from "./pCasemanProcessConfig/pCasemanProcessConfig.directive";
import { pCasemanTeamProcessConfigDirective } from "./pCasemanTeamProcessConfig/pCasemanTeamProcessConfig.directive";
import { bMatchActionsDirective } from "./bMatchActions/bMatchActions.directive";
import { bCasemanMenuDirective } from "./bCasemanMenu/bCasemanMenu.directive";
import { pCasemanIntegrationSettingsDirective } from './pCasemanIntegrationSettings/pCasemanIntegrationSettings.directive';

import { StatisticsService } from './pCasemanSync/StatisticsService.service';
import { UtilsService } from './Utils.service';
import { CasemanService } from "./Caseman.service";

export default angular.module('frontend.caseman', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pCasemanMatch', pCasemanMatchDirective)
  .directive('pCasemanProjectConfig', pCasemanProjectConfigDirective)
  .directive('pCasemanMatchProcess', pCasemanMatchProcessDirective)
  .directive('pCasemanCustomizeProcess', pCasemanCustomizeProcessDirective)
  .directive('pCasemanSync', pCasemanSyncDirective)
  .directive('pCasemanSiteConfig', pCasemanSiteConfigDirective)
  .directive('pCasemanTeamsConfig', pCasemanTeamsConfigDirective)
  .directive('pCasemanTeamConfig', pCasemanTeamConfigDirective)
  .directive('pCasemanTeamUserConfig', pCasemanTeamUserConfigDirective)
  .directive('pCasemanUserConfig', pCasemanUserConfigDirective)
  .directive('pCasemanClientConfig', pCasemanClientConfigDirective)
  .directive('pCasemanClientNewConfig', pCasemanClientNewConfigDirective)
  .directive('pCasemanTeamClientConfig', pCasemanTeamClientConfigDirective)
  .directive('pCasemanTeamClientErp', pCasemanTeamClientErpDirective)
  .directive('pCasemanPgConfig', pCasemanPgConfigDirective)
  .directive('pCasemanTeamPgConfig', pCasemanTeamPgConfigDirective)
  .directive('pCasemanProcessConfig', pCasemanProcessConfigDirective)
  .directive('pCasemanTeamProcessConfig', pCasemanTeamProcessConfigDirective)
  .directive('bMatchActions', bMatchActionsDirective)
  .directive('bCasemanMenu', bCasemanMenuDirective)
  .directive('pCasemanIntegrationSettings', pCasemanIntegrationSettingsDirective)
  .service('Statistics', StatisticsService)
  .service('Utils', UtilsService)
  .service('Caseman', CasemanService);
